import { render, staticRenderFns } from "./team-list.vue?vue&type=template&id=c16c59c4&scoped=true&"
import script from "./team-list.vue?vue&type=script&lang=js&"
export * from "./team-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16c59c4",
  null
  
)

export default component.exports